import { RoundedCard } from "../../shared/RoundedCard"
import { Flex, Label, Tab, Tabs } from "@braze/beacon-core"
import { useEffect, useState } from "react";
import { ViewTitle } from "../../shared/ViewTitle";
import { Table, TableBody, TableHeader, TableHeaderCell, TableRow, } from "@braze/beacon-labs-table";
import { CampaignTableRow } from "./CampaignTableRow";
import { Nullable } from "../../types/Nullable";
import { CampaignObject } from "../../types/APITypes";
import { FilterIcons, StatusFilter } from "../../shared/StatusFilter";
import { useColor } from '@braze/beacon-styling';
import { Select } from "@braze/beacon-lab-select";
import { QUARTERS, YEARS } from "../../constants/SelectConstants";
import { formatOption } from '../../util/optionsFormatter';
import { FiltersType, useOverviewContext } from "../../contexts/OverviewContext";
import { useGlobalAppContext } from "../../contexts/GlobalAppContext";



export const CampaignOverview = () => {
    
    const { campaigns } = useGlobalAppContext();
    const { filters, setFilters } = useOverviewContext();
    const colorGetter = useColor()
    const [activeTab, setActiveTab] = useState<number|string>(1);
    const [campaignsByRegion, setCampaignsByRegion] = useState<Nullable<CampaignObject[]>>(campaigns);

    const handleFilterChange = (key : keyof FiltersType) => {

        return (value? : number) => {
            if (value !== undefined) {
                setFilters({...filters, [key] : value})
            } else {
                setFilters({...filters, [key] : !filters[key]})
            }
        }
    }

    console.log(filters)

    useEffect(() =>{

        const filterCampaigns = () => {
            if (campaigns !== null) {
                var filtered:CampaignObject[] = [];
                filtered = JSON.parse(JSON.stringify(campaigns));

                if (activeTab === 1) { 
                    filtered = filtered.filter(camp => camp["campaign_region"] === "Global");
                } else if (activeTab === 2) { 
                    filtered = filtered.filter(camp => camp["campaign_region"] === "AMER");
                } else if (activeTab === 3) {
                    filtered = filtered.filter(camp => camp["campaign_region"] === "APAC");
                } else if (activeTab === 4) {
                    filtered = filtered.filter(camp => camp["campaign_region"] === "EMEA");
                } else if (activeTab === 5) {
                    filtered = filtered.filter(camp => camp["campaign_region"] === "Japan");
                }
                
                let statuses:string[] = []
                
                if (filters.submitted) {statuses.push("Submitted");}
                if (filters.approved) {statuses.push("Approved - Pending MarOps Review");}
                if (filters.launched) {statuses.push("Launched");}
                if (filters.rejected) {statuses.push("Rejected");}

                filtered = filtered.filter(camp => statuses.includes(camp["approval_status"]));

                if (filters.fiscal_quarter) {filtered = filtered.filter(camp => filters.fiscal_quarter === camp["fiscal_quarter"]);}
                if (filters.fiscal_year) {filtered = filtered.filter(camp => filters.fiscal_year === camp["fiscal_year"]);}                
                setCampaignsByRegion([...filtered]);
            }
        }
        filterCampaigns();
    }, [campaigns, activeTab, filters]);

    console.log(campaignsByRegion);

    return campaigns !== null ? (
        <RoundedCard style={{width:"80%"}}>
            <Flex justifyContent="space-between">
                <ViewTitle title="View All Active Campaigns"/>
                <FiscalFilters/>
            </Flex>
            
            <Flex style={{alignItems:"center", marginBottom:"1rem", justifyContent: "space-between"}}>
                <Tabs activeTab={activeTab} onChange={(tab: number|string) => setActiveTab(tab)} style={{display: "flex", width: "50%"}}>
                    <Tab tabId={1}>
                        Global
                    </Tab>
                    <Tab tabId={2}>
                        AMER
                    </Tab>
                    <Tab tabId={3}>
                        APAC
                    </Tab>
                    <Tab tabId={4}>
                        EMEA
                    </Tab>
                    <Tab tabId={5}>
                        Japan
                    </Tab>
                </Tabs>
                
                <StatusFilter>
                    <FilterIcons title="Submitted" icon="arrow-up-from-bracket" active={filters.submitted} color={colorGetter("orange", 400)} 
                        id="Submitted" setActive={handleFilterChange('submitted')}/>
                    <FilterIcons title="Approved" icon="check" active={filters.approved} color={colorGetter("lightGreen", 400)} 
                        id="Approved - Pending MarOps Review" setActive={handleFilterChange('approved')}/>
                    <FilterIcons title="Launched" icon="rocket" active={filters.launched} color={colorGetter("blue", 400)} 
                        id="Launched" setActive={handleFilterChange('launched')}/>
                    <FilterIcons title="Rejected" icon="xmark" active={filters.rejected} color={colorGetter("red", 500)} 
                        id="Rejected" setActive={handleFilterChange('rejected')}/>
                </StatusFilter>
            </Flex>
            
            <Table fullWidth>
                <TableHeader>
                    <TableRow>
                        <TableHeaderCell>Campaign Name</TableHeaderCell>
                        <TableHeaderCell>Submission Date</TableHeaderCell>
                        <TableHeaderCell>Status</TableHeaderCell>
                    </TableRow>
                </TableHeader>
                <TableBody>
                    {campaignsByRegion?.map((c : CampaignObject) => {
                        return (
                            <TableRow>
                                <CampaignTableRow campaign={c}/>
                            </TableRow>
                        )
                    })}
                </TableBody>
            </Table>
        </RoundedCard>
        
    ) : (
        <div></div>
    )
};


const FiscalFilters = () => {
    
    const { filters, setFilters } = useOverviewContext()

    const handleFieldChange = (key : keyof FiltersType) => {

        return (value : any ) => {
            
            if (typeof value === "object" && value != null) {
                setFilters({...filters, [key] : Number(value["value"])})
            } else {setFilters({...filters, [key] : value})}
            
        }
    }

    const style = {
        display: "flex",
        minWidth: "30%",
        justifyContent: "space-between",
        alignItems: "center"
    }

    console.log(filters);

    return (
        <Flex style={style}>
            <Label style={{marginBottom: "0", marginRight: "1rem"}}>FY:</Label>
            <Select
                fluid
                options={formatOption(YEARS).slice(0, -1)}
                onChange={(selectedOption) => {handleFieldChange("fiscal_year")(selectedOption);}}
                 
             />
            <Label style={{marginBottom: "0", marginRight: "1rem", marginLeft: "1.5rem"}}>FQ:</Label>
            <Select
                fluid
                options={formatOption(QUARTERS)}
                onChange={(selectedOption) => {handleFieldChange("fiscal_quarter")(selectedOption);}}
                
            />
        </Flex>
    )
}